// user-state.service.ts
import { Injectable, signal, computed, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { firstValueFrom, switchMap } from 'rxjs';
import { environment } from 'apps/web/src/environments/environment';
import { AuthService } from '../../auth/services/auth.service';
import { UserInfo, UserStateService } from '@net3-multiplatform-client/libs';
import { ExistsUser } from '../../../domain/user/user.interface';


@Injectable({ providedIn: 'root' })
export class UserService {
  userStateService = inject(UserStateService)

  // per evitar multiples peticions en paralel
  private _loadInProgress: Promise<UserInfo> | null = null;

  private options = environment;
  private apiUrl: string;
  
  private user = this.userStateService.user;

  constructor(private http: HttpClient, private authService: AuthService) {
    this.apiUrl = `${this.options.baseUrl.auth}`;
  }

  /**
   * Carrega la info d'usuario.
   * - Si ja esta carregat, retorna el valor ja guardat(Promise resolta).
   * - Si hi ha una petición en curs, retorna la mateixa Promise.
   * - Si no hi ha res, fa la petición a /users/auth.
   */
  loadUserInfo(): Promise<UserInfo> {
    // Ja tenim usuari en memoria. Retornem la promesa amb l'usuari directament
    if (this.user()) {
      return Promise.resolve(this.user()!);
    }

    // Ja hi ha peticio en marxa, es retorna aquesta
    if (this._loadInProgress) {
      return this._loadInProgress;
    }

    this._loadInProgress = firstValueFrom(
      this.authService.getValidJwt$().pipe(
        switchMap(jwt => {
          if (!jwt || this.authService.isExpired(jwt)) {
            throw new Error('JWT no disponible o expirado');
          }

          const url = `${this.apiUrl}/users/auth`;
          
          return this.http.get<UserInfo>(url)
        })
      )
    )
      .then(user => {
        this.userStateService.setUser(user);
        this._loadInProgress = null;
        return user;
      })
      .catch(err => {
        this._loadInProgress = null;
        throw err; // TODO: decidir que fer en cas d'error al fer la peticó
      });

    return this._loadInProgress;
  }

  globalUserExists(email: string){
    const baseUrl = `${this.apiUrl}/users/auth`;
    
    let params = new HttpParams()
    params.append(email, email);
    
    return this.http.get<ExistsUser>(baseUrl, {params})
  }
}